import { resolveHomePath } from "@/features/auth/guards";
import { auth } from "@/lib/firebase/client";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Default /app route — redirect based on user role
export const Route = createFileRoute("/app/")({
  beforeLoad: async () => {
    if (typeof auth.authStateReady === "function") {
      await auth.authStateReady();
    }

    const user = auth.currentUser;
    if (!user) {
      throw redirect({ to: "/signin" });
    }

    const token = await user.getIdTokenResult(true);
    throw redirect({ to: resolveHomePath(token.claims) });
  },
  component: () => null,
});
